/**
 * analytics — one-line client for firing lightweight discovery
 * events at `/api/analytics/track`. Fire-and-forget by design; the
 * caller never awaits and the request never surfaces errors to
 * the user.
 *
 * Documented event names (keep this list in sync with the docstring
 * in /app/backend/routes/analytics.py):
 *
 *   foundation_pill_click     — user tapped the emerald pill on a
 *                               DegreeDetail or Advanced Results card
 *   foundation_chip_toggle    — user flipped the "Foundation year only"
 *                               filter chip on Advanced Results
 *   fe_narrow_match_cta       — user clicked "Narrow my match to just
 *                               FE colleges" from the FE landing
 *   inst_multiselect_apply    — user selected 2+ institution types in
 *                               the Advanced Results dropdown
 *   compare_short_created     — a compare-uni URL was shortened
 *   compare_short_resolved    — a shortened compare-uni URL was
 *                               followed to its target
 *   firm_page_view            — /how-to-get-into/{slug} rendered.
 *                               Optional props.referrer_subject when
 *                               arrived from a degree-page firm chip.
 *   firm_employer_page_view   — /employers/{slug} rendered.
 *   firm_rsvp_click           — user clicked RSVP on an event card
 *                               (props.event_id required).
 *   firm_cta_click            — user clicked the firm-submitted CTA
 *                               URL on the firm page.
 */
import { api } from "@/lib/api";

export function trackEvent(event, props = {}) {
  try {
    // Fire-and-forget — no `.then`, no `.catch` surfaced. If the
    // server is down we don't care; this is a signal channel, not
    // a critical path.
    api.post("/analytics/track", { event, props }).catch(() => {});
  } catch (_e) {
    // Swallow — analytics must never break the UI.
  }
}
